import React from 'react'
import { StyleSelectorFormsy } from 'app/main/notification/components/StyleSelectFormsy'
import { MenuItem } from '@material-ui/core'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import { useFetcher } from 'libs/fetcher'
import { isEmptyOrNil } from 'libs/empty'

const isNotNilOrEmpty = R.compose(R.not, R.anyPass([R.isNil, R.isEmpty]))
const getError = R.prop('errors')

export const validateRequired = (values, value) =>
  R.allPass([isNotNilOrEmpty, R.compose(isEmptyOrNil, getError)])(value)
const StatefulSelector = (props) => {
  const {
    initialItemId,
    fetcher,
    LoadingComp,
    ErrorComp,
    EmptyComp,
    ValidComp,
    ...rest
  } = props
  const state = useFetcher(fetcher, undefined)

  const isLoading = R.prop('isLoading')(state)
  const errors = R.prop('errors')(state)
  const items = R.path(['values', 'data'])(state)
  const canRenderItems = isLoading === false && !isNotNilOrEmpty(errors)

  const getSelectedItem = R.compose(
    R.defaultTo(''),
    R.ifElse(
      () => !isNotNilOrEmpty(initialItemId),
      R.always(''),
      R.find(R.propEq('id', initialItemId)),
    ),
    R.defaultTo([]),
  )

  const selectorState = R.ifElse(
    () => canRenderItems,
    getSelectedItem,
    R.always({
      isLoading,
      errors,
    }),
  )(items)

  return (
    <StyleSelectorFormsy
      {...rest}
      value={selectorState}
      renderValue={(value) => {
        if (isLoading) return LoadingComp
        if (isNotNilOrEmpty(errors)) return ErrorComp(errors)
        else {
          if (!isNotNilOrEmpty(items)) return EmptyComp
          return ValidComp(value)
        }
      }}
      FormControlProps={{
        disabled: isLoading || isNotNilOrEmpty(errors),
      }}
    >
      {!isNotNilOrEmpty(items)
        ? null
        : items.map((item) => (
            <MenuItem key={item.id} value={item}>
              {ValidComp(item)}
            </MenuItem>
          ))}
    </StyleSelectorFormsy>
  )
}

StatefulSelector.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  initialItemId: PropTypes.number,
}

export default React.memo(StatefulSelector)
